import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { LivetrackService } from 'src/app/services/livetrack.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
// import { ImageViewerModule } from 'ng2-image-viewer';
import { DirectivesModule } from 'src/app/views/layout/directives/directives.module';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import { RegionService } from 'src/app/services/region.service';
import { DivisionService } from 'src/app/services/division.service';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectFilterModule } from 'mat-select-filter';
import { PaccsuserComponent } from './paccsuser.component';
import { PaccsuserviewComponent } from './paccsuserview.component';
import { LoaderModule } from 'src/app/views/layout/loader/loader.module';

const routes: Routes = [
  {
      path: '',
      component: PaccsuserComponent 
  },
  {
      path: ':id/:actionInfo',
      component: PaccsuserviewComponent
  }
]

@NgModule({
  declarations: [PaccsuserComponent, PaccsuserviewComponent],
  providers: [
    UserService,
    LivetrackService,
    RegionService,
    DivisionService,
    SubDivisionService
    // ImageViewerModule
],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    FeahterIconModule,
    NgbDropdownModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    DirectivesModule,
    MatSelectModule, 
    MatSelectFilterModule,
    LoaderModule
  ]
})
export class PaccsuserModule { }
